import apiClient from "./apiClient";
const resource = "/rooms";

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(uuid, data) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
  async search(keyword) {
    return apiClient.get(`${resource}/search?keyword=${keyword}`);
  },
  async filter(category, status) {
    return apiClient.get(
      `${resource}/filter?room_category=${category}&status=${status}`
    );
  },

  // ================================
  // 🔥 AVAILABILITY (POST)
  // ================================
  async availability(data) {
    return apiClient.post(`${resource}/availability`, data);
  },
  async search_availability(keyword, start, end) {
    return apiClient.get(`${resource}/search?keyword=${keyword}&start=${start}&end=${end}`);
  },
};
